"use client"

import { useEffect } from "react"
import { AgentDemo } from "@/src/components/agent/agent-demo"
import type { AgentDemoStep } from "@/lib/agent-demo-data"
import { trackPageDuration } from "@/src/utils/analytics"

export function AppShell({
  initialQuery = "",
  demoSteps,
  onGoToSkills,
  onGoToLanding,
  selectedScenarioId,
}: {
  initialQuery?: string
  demoSteps: AgentDemoStep[]
  onGoToSkills?: () => void
  onGoToLanding?: () => void
  selectedScenarioId?: string
}) {
  useEffect(() => trackPageDuration("chat"), [])

  return (
    <div className="flex h-dvh flex-col chat-teal-theme pt-14">
      {/* Content — header is now provided by the global TopBar */}
      <AgentDemo initialQuery={initialQuery} demoSteps={demoSteps} selectedScenarioId={selectedScenarioId} />
    </div>
  )
}
